import VcForm from 'src/shared/form/VcForm';
import messagePage from 'src/shared/messagePage/MessagePage';
import directives from 'src/shared/directives';

const components = { VcForm, messagePage };

function plugin(Vue) {
  Object.keys(components).forEach((key) => {
    Vue.component(key, components[key]);
  });

  Object.keys(directives).forEach((key) => {
    Vue.directive(key, directives[key]);
  });
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(plugin);
}

export default plugin;
